import { useSyncExternalStore } from 'react'
import { OPS_COMPACT_BREAKPOINT } from './layout'

const query = window.matchMedia(`(max-width: ${OPS_COMPACT_BREAKPOINT - 1}px)`)

/** Below the breakpoint the sidebar floats over the page instead of taking a column. */
export function useCompactLayout(): boolean {
  return useSyncExternalStore(
    (listener) => {
      query.addEventListener('change', listener)
      return () => query.removeEventListener('change', listener)
    },
    () => query.matches,
  )
}
